export const TICKET_CATEGORIES: Record<string, { label: string; color: string; bg: string }> = {
  fiscal: { label: 'Fiscal', color: 'text-blue-700', bg: 'bg-blue-100' },
  contabil: { label: 'Contábil', color: 'text-green-700', bg: 'bg-green-100' },
  pessoal: { label: 'Depto. Pessoal', color: 'text-orange-700', bg: 'bg-orange-100' },
  societario: { label: 'Societário', color: 'text-purple-700', bg: 'bg-purple-100' },
  consultoria: { label: 'Consultoria', color: 'text-yellow-700', bg: 'bg-yellow-100' },
  outros: { label: 'Outros', color: 'text-gray-700', bg: 'bg-gray-100' },
};

export const PRIORITIES: Record<string, { label: string; color: string; bg: string }> = {
  low: { label: 'Baixa', color: 'text-gray-600', bg: 'bg-gray-100' },
  medium: { label: 'Média', color: 'text-blue-600', bg: 'bg-blue-100' },
  high: { label: 'Alta', color: 'text-orange-600', bg: 'bg-orange-100' },
  urgent: { label: 'Urgente', color: 'text-red-600', bg: 'bg-red-100' },
};

export const CONVERSATION_STATUSES: Record<string, { label: string; color: string }> = {
  open: { label: 'Aberta', color: 'text-green-600' },
  waiting: { label: 'Aguardando', color: 'text-yellow-600' },
  closed: { label: 'Encerrada', color: 'text-gray-500' },
};

export const KANBAN_COLUMNS = [
  { id: 'backlog', title: 'Backlog', color: 'border-gray-400' },
  { id: 'todo', title: 'A Fazer', color: 'border-blue-400' },
  { id: 'in_progress', title: 'Em Andamento', color: 'border-yellow-400' },
  { id: 'review', title: 'Em Revisão', color: 'border-purple-400' },
  { id: 'done', title: 'Concluído', color: 'border-green-400' },
];

// Dias da semana na ordem do contrato do backend de heatmaps (#62):
// indice 0=Seg .. 6=Dom (mesma ordem do campo `weekday`).
export const DAYS_OF_WEEK = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];

export const USER_ROLES: Record<string, string> = {
  admin: 'Administrador',
  supervisor: 'Supervisor',
  agent: 'Agente',
};
